import React from 'react';
import { ClassAssembly10D2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly10D2026 />;
  };
  
  export default ClassAssemblyPage;